module.exports = __webpack_public_path__ + "static/media/Renovation-Villas-Vaud.69aa599b.jpg";